import { Component, Input, OnInit } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Kontakt } from '../../../shared/models/kontakt.model';
import { MobileMessageDialogComponent } from '../mobile-message-dialog/mobile-message-dialog.component';

@Component({
  selector: 'ngx-header-contact-menu',
  templateUrl: './header-contact-menu.component.html',
  styleUrls: ['./header-contact-menu.component.scss']
})
export class HeaderContactMenuComponent implements OnInit {
  @Input() kontakt: Kontakt;
  
  isDropdownOpen = false;

  constructor(
    private dialogService: NbDialogService
  ) {}

  ngOnInit(): void {}

  toggleDropdown(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeDropdown(): void {
    this.isDropdownOpen = false;
  }

  callPhone(phoneNumber: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (phoneNumber) {
      window.location.href = `tel:${phoneNumber}`;
    }
    this.closeDropdown();
  }

  sendEmail(email: string, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    if (email) {
      window.location.href = `mailto:${email}`;
    }
    this.closeDropdown();
  }

  openMessageDialog(event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    
    this.dialogService.open(MobileMessageDialogComponent, {
      context: {
        preselectedRecipient: 'KSIEGOWY'
      }
    });
    this.closeDropdown();
  }

  getMainPhone(): string {
    return this.kontakt?.opiekunGlownyTelefon || this.kontakt?.opiekunGlownyTelefonKomorkowy || '';
  }

  getMainEmail(): string {
    return this.kontakt?.opiekunGlownyEmail || '';
  }

  shouldAlignRight(): boolean {
    // Check if we're on a small screen and should align dropdown to the right
    return window.innerWidth <= 400;
  }
}
